var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuAccounts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00183 2C2.44955 2 2.00183 2.44772 2.00183 3V7C2.00183 7.55228 2.44955 8 3.00183 8H19.0018C19.5541 8 20.0018 7.55228 20.0018 7V3C20.0018 2.44772 19.5541 2 19.0018 2H3.00183ZM0.00183105 3C0.00183105 1.34315 1.34498 0 3.00183 0H19.0018C20.6587 0 22.0018 1.34315 22.0018 3V7C22.0018 8.65685 20.6587 10 19.0018 10H3.00183C1.34498 10 0.00183105 8.65685 0.00183105 7V3Z",
    fill: "#BB85FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00183 14C2.44955 14 2.00183 14.4477 2.00183 15V19C2.00183 19.5523 2.44955 20 3.00183 20H19.0018C19.5541 20 20.0018 19.5523 20.0018 19V15C20.0018 14.4477 19.5541 14 19.0018 14H3.00183ZM0.00183105 15C0.00183105 13.3431 1.34498 12 3.00183 12H19.0018C20.6587 12 22.0018 13.3431 22.0018 15V19C22.0018 20.6569 20.6587 22 19.0018 22H3.00183C1.34498 22 0.00183105 20.6569 0.00183105 19V15Z",
    fill: "#BB85FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00183 5C4.00183 4.44772 4.44955 4 5.00183 4H5.01183C5.56412 4 6.01183 4.44772 6.01183 5C6.01183 5.55228 5.56412 6 5.01183 6H5.00183C4.44955 6 4.00183 5.55228 4.00183 5Z",
    fill: "#BB85FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00183 17C4.00183 16.4477 4.44955 16 5.00183 16H5.01183C5.56412 16 6.01183 16.4477 6.01183 17C6.01183 17.5523 5.56412 18 5.01183 18H5.00183C4.44955 18 4.00183 17.5523 4.00183 17Z",
    fill: "#BB85FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAccounts);
export default __webpack_public_path__ + "static/media/menu-accounts.b2bccdd2b7bd920a0a1a61b118555a6b.svg";
export { ForwardRef as ReactComponent };